import React, { useState, Fragment } from "react";
import { Col, Row, Button, Container, Modal, ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";

import { getSession, getCurrentAccount, getSavedPersonInfo } from "../../../reducers/selectors";

import style from "./PersonalDataModal.scss";

export const PersonalDataModal = ({ handleAuthorize }) => {
  const personInfo = useSelector(getSavedPersonInfo);

  const [mobilePhone, setMobilePhone] = useState({
    PhoneNumber: "",
  });
  const [personDocument, setPersonDocument] = useState({
    PhysicalPersonDocumentTypeName: "",
    PhysicalPersonDocumentNumber: "",
  });
  const [legalAddress, setLegalAddress] = useState({
    LegalAddressStreet: "",
    LegalAddressCityName: "",
  });

  const genderString = {
    N: "No especificado",
    M: "Masculino",
    F: "Femenino",
  };

  const civilStatusString = {
    Single: "Soltero/a",
    Engaged: "Comprometido/a",
    Married: "Casado/a",
    Divorced: "Divorciado/a",
    Widower: "Viudo/a",
  };

  useEffect(() => {
    // actualizar datos de persona
    if (personInfo) {
      if (personInfo.Phone.length > 0) {
        const newMobilePhone = personInfo.Phone.find((phoneItem) => phoneItem.PhoneType === "Mobile");
        setMobilePhone((prev) => ({
          ...prev,
          ...newMobilePhone,
        }));
      }

      if (personInfo.Documents.length > 0) {
        const newPersonDocument = personInfo.Documents.find(
          (documentItem) => documentItem.PhysicalPersonDocumentIsMain
        );
        setPersonDocument((prev) => ({
          ...prev,
          ...newPersonDocument,
        }));
      }

      if (personInfo.LegalAddress.length > 0) {
        const newLegalAddress = personInfo.LegalAddress[0];
        setLegalAddress((prev) => ({
          ...prev,
          ...newLegalAddress,
        }));
      }
    }
  }, [personInfo]);

  if (!personInfo) return <CircularProgress />;

  return (
    <Modal size="lg" isOpen contentClassName={style.content}>
      <ModalBody>
        <div className={style.body}>
          <Fragment>
            <Container className={style.container}>
              <p className={style.subTitle}>Confirmá tus datos</p>

              {personInfo && (
                <Row className={style.gridRow}>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Nombre y Apellido</p>
                    <p
                      className={style.text}
                    >{`${personInfo.PhysicalPersonFirstName} ${personInfo.PhysicalPersonFirstLastName}`}</p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Género</p>
                    <p className={style.text}>{genderString[personInfo.PhysicalPersonGender]}</p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Fecha de Nacimiento</p>
                    <p className={style.text}>
                      {moment(personInfo.PhysicalPersonDateOfBirth).format("DD/MM/YYYY")}
                    </p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Nacionalidad</p>
                    <p className={style.text}>{personInfo.PhysicalPersonNationality}</p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Estado Civil</p>
                    <p className={style.text}>{civilStatusString[personInfo.PhysicalPersonCivilStatus]}</p>
                  </Col>
                  <Col className={style.col} xs={12} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Dirección</p>
                    <p className={style.text}>
                      {`${legalAddress.LegalAddressStreet} ${legalAddress.LegalAddressNumber}, ${legalAddress.LegalAddressCityName}`}
                    </p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Celular</p>
                    <p className={style.text}>{mobilePhone.PhoneNumber}</p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Correo electrónico</p>
                    <p className={style.text}>{personInfo.PhysicalPersonEmail}</p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Tipo de documento</p>
                    <p className={style.text}>{personDocument.PhysicalPersonDocumentTypeName}</p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Número de documento</p>
                    <p className={style.text}>{personDocument.PhysicalPersonDocumentNumber}</p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Ocupación</p>
                    <p className={style.text}>{personInfo.PersonProfessionName}</p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Nombre de la empresa</p>
                    <p className={style.text}>{personInfo.PhysicalPersonInstitution}</p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Ciudad (laboral)</p>
                    <p className={style.text}>{legalAddress.LegalAddressCityName}</p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}>
                    <p className={style.greySubtitle}>Actividad del negocio</p>
                    <p className={style.text}>{personInfo.PersonActivitySectorName}</p>
                  </Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}></Col>

                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}></Col>
                  <Col className={style.col} xs={6} sm={4} md={4} lg={4} xl={4} xxl={4}></Col>
                  <Col
                    className={`${style.col} ${style.buttonColumn}`}
                    xs={6}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                    xxl={4}
                  >
                    <Button className={style.confirmButton} onClick={handleAuthorize}>
                      confirmar datos
                    </Button>
                  </Col>
                </Row>
              )}
            </Container>
          </Fragment>
        </div>
      </ModalBody>
    </Modal>
  );
};
